@if (newTemplate) {
  <form [formGroup]="addressForm">
    <h4 class="font-weight-semibold font-size-1-50">{{ addressChange.header }}</h4>
    <ds-form-control-container [labelText]="addressChange.addressLine1" [control]="address1">
      <input
        type="text"
        id="address1"
        class="fill"
        formControlName="address1"
        data-cy="requestChangeAddressLine1Input"
      />
      <ds-form-control-message [control]="address1"></ds-form-control-message>
    </ds-form-control-container>

    <ds-form-control-container [labelText]="addressChange.addressLine2" [control]="address2">
      <input
        type="text"
        id="address2"
        class="fill"
        formControlName="address2"
        data-cy="requestChangeAddressLine1Input"
      />
      <ds-form-control-message [control]="address2"></ds-form-control-message>
    </ds-form-control-container>

    <div class="horizontal-align">
      <ds-form-control-container [labelText]="addressChange.city" [control]="city">
        <input
          type="text"
          id="city"
          class="fill"
          formControlName="city"
          data-cy="requestChangeAddressLine1Input"
        />
        <ds-form-control-message [control]="city"></ds-form-control-message>
      </ds-form-control-container>

      <ds-form-control-container [labelText]="addressChange.state" [control]="state">
        <select
          id="stateInput"
          class="icon fill"
          formControlName="state"
          data-cy="requestChangeAddressStateSelect"
        >
          @for (state of states; track state) {
            <option [value]="state?.value">{{ state?.name }}</option>
          }</select
        ><span class="icon-chevron-down"></span>
        <ds-form-control-message [control]="state"></ds-form-control-message>
      </ds-form-control-container>

      <ds-form-control-container [labelText]="addressChange.zipCode" [control]="zip">
        <input
          type="text"
          id="zip"
          class="fill"
          formControlName="zip"
          data-cy="requestChangeAddressLine1Input"
        />
        <ds-form-control-message [control]="zip"></ds-form-control-message>
      </ds-form-control-container>
    </div>

    <div class="pad-top-16">
      <div class="font-9 pad-bottom-10 flex">
        {{ addressChange.sendDocuments }}
        <button
          class="info__button"
          data-cy="infoButton"
          triggerOn="click"
          [tooltip]="addressChangeRef"
          [showCloseButton]="true"
          [closeOnClickingOutside]="true"
          [closeOnEscape]="true"
          actionButtonsRef="close"
        >
          <i class="icon-info"></i>
        </button>
      </div>
      <div class="radio-group">
        <ds-radio-group
          class="options"
          control="sendDocuments"
          [parentFormGroup]="addressForm"
          [options]="documentOptions"
          selectedAnswer="1"
        >
        </ds-radio-group>
      </div>
    </div>

    @if (risks?.length) {
      @if (vehiclesGaraged) {
        <div class="pad-top-16">
          <div class="font-9 pad-bottom-10">{{ addressChange.vehiclesGaraged }}</div>
          <div class="radio-group">
            <ds-radio-group
              class="options"
              control="vehiclesGaraged"
              [parentFormGroup]="addressForm"
              [options]="garagedOptions"
              selectedAnswer="1"
            >
            </ds-radio-group>
          </div>
        </div>
      }

      @if (!!vehiclesGaraged?.value?.value) {
        <div class="pad-top-16">
          <div class="font-9 pad-bottom-10">{{ addressChange.selectVehicles }}</div>
          <ds-checkbox-group
            controlName="vehicles"
            [parentFormGroup]="addressForm"
            [options]="vehicleOptions"
            displayClass="flex"
          >
          </ds-checkbox-group>
        </div>
      }
    }

    <ds-form-control-container [labelText]="addressChange.reason" [control]="reason">
      <textarea
        maxlength="850"
        id="reasonText"
        class="fill"
        formControlName="reason"
        rows="10"
        data-cy="requestChangeReasonInput"
        textCounter
        [maxCount]="850"
      ></textarea>
      <ds-form-control-message [control]="reason"></ds-form-control-message>
    </ds-form-control-container>

    <call-to-action
      [primaryButtonName]="addressChange.submit"
      [tertiaryButtonName]="addressChange.cancel"
      [capitalize]="true"
      [disablePrimaryButton]="!valid"
      (primaryEvent)="onSubmit()"
      (tertiaryEvent)="cancel()"
    >
    </call-to-action>
  </form>

  <ng-template #addressChangeRef>
    <div class="tooltip-content-wrapper">
      <ds-content-wrapper context="addresschange"></ds-content-wrapper>
    </div>
  </ng-template>
  <ds-modal
    [id]="agentsModal"
    [closeOthers]="true"
    [showCloseButton]="false"
    [closeOnBackdropClick]="false"
  >
    <div class="margin-bottom-20">
      <app-agent-selector
        [agents]="agents"
        primaryButtonName="Submit"
        secondaryButtonName="Cancel"
        (sendToAgent)="sendToAgent($event)"
        (cancel)="closeModal()"
      ></app-agent-selector>
    </div>
  </ds-modal>
} @else {
  <form [formGroup]="addressGroup" (ngSubmit)="submit()">
    <div class="row">
      <fieldset id="personal-info" class="column twelve pad-bottom-16">
        <legend class="pad-vertical-10" dsContent [contentPath]="'policy.addressInfoText'"></legend>
        <div class="row">
          <div class="column twelve md-six">
            <ds-form-control-container
              labelText="Street Address"
              [control]="streetAddressLine1Input"
            >
              <input
                type="text"
                id="streetAddressLine1Input"
                class="fill"
                formControlName="streetAddressLine1Input"
                data-cy="requestChangeAddressLine1Input"
              />
              <ds-form-control-message
                [control]="streetAddressLine1Input"
              ></ds-form-control-message>
            </ds-form-control-container>
          </div>
        </div>
        <div class="row">
          <div class="column twelve md-six">
            <ds-form-control-container
              labelText="Street Address 2 (Optional)"
              [control]="streetAddressLine2Input"
            >
              <input
                type="text"
                id="streetAddressLine2Input"
                class="fill"
                formControlName="streetAddressLine2Input"
                data-cy="requestChangeAddressLine2Input"
              />
              <ds-form-control-message
                [control]="streetAddressLine2Input"
              ></ds-form-control-message>
            </ds-form-control-container>
          </div>
        </div>
        <div class="row">
          <div class="column twelve md-four">
            <ds-form-control-container labelText="City" [control]="cityInput">
              <input
                type="text"
                id="cityInput"
                class="fill"
                formControlName="cityInput"
                data-cy="reqeustChangeAddressCityInput"
              />
              <ds-form-control-message [control]="cityInput"></ds-form-control-message>
            </ds-form-control-container>
          </div>
          @if (!!states?.length) {
            <div class="column twelve md-two md-pad-left-10">
              <ds-form-control-container labelText="State" [control]="stateInput">
                <select
                  id="stateInput"
                  class="icon fill"
                  formControlName="stateInput"
                  data-cy="requestChangeAddressStateSelect"
                >
                  @for (state of states; track state) {
                    <option [value]="state?.value">{{ state?.name }}</option>
                  }</select
                ><span class="icon-chevron-down"></span>
                <ds-form-control-message [control]="stateInput"></ds-form-control-message>
              </ds-form-control-container>
            </div>
          }
          <div class="column twelve md-two md-pad-left-10">
            <ds-form-control-container labelText="ZIP Code" [control]="zipcodeInput">
              <input
                type="text"
                id="zipcodeInput"
                class="fill"
                formControlName="zipcodeInput"
                data-cy="requestChangeAddressZipCodeInput"
              />
              <ds-form-control-message [control]="zipcodeInput"></ds-form-control-message>
            </ds-form-control-container>
          </div>
        </div>
      </fieldset>
    </div>

    <!-- User Comments section -->
    <div class="row">
      <fieldset id="comments" class="column twelve">
        <legend
          class="pad-vertical-10"
          dsContent
          [contentPath]="'policy.policyCommentsAdditionalInfoText'"
        ></legend>
        <ds-form-control-container
          labelText="Details (max 850 characters)"
          [control]="commentInputCtrl"
        >
          <textarea
            maxlength="850"
            id="commentInput"
            class="fill"
            formControlName="commentInputCtrl"
            rows="5"
            data-cy="requestChangeDetailsInput"
          ></textarea>
          <ds-form-control-message [control]="commentInputCtrl"></ds-form-control-message>
        </ds-form-control-container>
        <span class="caption" dsContent [contentPath]="'policy.policyChangeDisclaimer'"></span>
      </fieldset>
    </div>

    <!-- Action Buttons -->
    <div class="row">
      <div class="column twelve callToAction">
        <span class="md-float-right">
          <a class="pad-horizontal-20" (click)="cancel()">Cancel</a>
          <button
            ds-button
            type="submit"
            class="-outline"
            aria-label="Submit"
            [disabled]="
              addressGroup?.invalid ||
              !addressGroup?.dirty ||
              !(roleService?.isAuthorized('reqpolicychangefrm_submit') | async)
            "
            data-cy="primaryButton"
          >
            Submit
          </button>
        </span>
      </div>
    </div>
  </form>
}
